// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__22ucX","content":"Consent_content__2Y9kN","footer":"Consent_footer__30iyZ"};